import * as Yup from 'yup';
import businessOwnerTypes from '../constants/businessOwnerTypes';

const businessOwnerTypeValidation = Yup.string()
  .nullable()
  .test(
    'business-owner-type-required',
    'Bitte Mann, Frau oder Firma auswählen.',
    (value, context) => !context.parent.business_owner?.trim() || businessOwnerTypes.some((type) => type === value),
  );

export default businessOwnerTypeValidation;
